export default "__VITE_ASSET__Wssepkcz__"